import AdminContainer from '../../Utility/AdminContainer';
import useSettings from '../../../Hooks/useSettings';
import GeneralSettings from './components/GeneralSettings';
import DataProtection from './components/DataProtection';
import InstanceSettings from './components/InstanceSettings';
import { SettingsTabName } from '../../../Types/Enums';
import ToggleSwitch from '../../Utility/ToggleSwitch';
import System from './components/System';
import AdvancedSettings from './components/AdvancedSettings';
import ExpertSettings from './components/ExpertSettings';
import Select from '../../Utility/FormElements/Select';
import ThemeSettings from './components/ThemeSettings';
import { useThemeSettings } from '../../../Hooks/useThemeSettings';

function Settings() {
    const {
        SettingsActions,
        models,
        embeddingModels,
        voiceModels,
        settingsLoaded,
        currentTab,
        setCurrentTab,
        userSettings,
        i18n,
        windowWidth,
        getBreakpoint,
        Currentsettings,
        mdParser,
    } = useSettings();

    const { imagePreviewDark, imagePreviewLight } = useThemeSettings(Currentsettings, SettingsActions);

    return (
        <div className={`admin-container flex relative flex-col`}>
            <AdminContainer>
                {settingsLoaded && (
                    <>
                        <div className="mb-5 w-full">
                            {windowWidth > getBreakpoint('md') ? (
                                <ToggleSwitch
                                    options={[
                                        {
                                            label: i18n.translate({ id: 'general', sourceName: 'Settings' }),
                                            function: () => setCurrentTab(SettingsTabName.general),
                                            active: currentTab === SettingsTabName.general,
                                        },
                                        {
                                            label: i18n.translate({ id: 'dataProtection', sourceName: 'Settings' }),
                                            function: () => setCurrentTab(SettingsTabName.dataprotection),
                                            active: currentTab === SettingsTabName.dataprotection,
                                        },
                                        {
                                            label: i18n.translate({ id: 'instance', sourceName: 'Settings' }),
                                            function: () => setCurrentTab(SettingsTabName.instanceSettings),
                                            active: currentTab === SettingsTabName.instanceSettings,
                                            renderCondition: userSettings.isAvency,
                                        },
                                        {
                                            label: i18n.translate({ id: 'themeSettings', sourceName: 'Settings' }),
                                            function: () => setCurrentTab(SettingsTabName.themeSettings),
                                            active: currentTab === SettingsTabName.themeSettings,
                                        },
                                        {
                                            label: i18n.translate({ id: 'advancedSettings', sourceName: 'Settings' }),
                                            function: () => setCurrentTab(SettingsTabName.advancedSettings),
                                            active: currentTab === SettingsTabName.advancedSettings,
                                        },
                                        {
                                            label: i18n.translate({ id: 'expertSettings', sourceName: 'Settings' }),
                                            function: () => setCurrentTab(SettingsTabName.expertSettings),
                                            active: currentTab === SettingsTabName.expertSettings,
                                            renderCondition: userSettings.expertViewEnabled,
                                        },
                                        {
                                            label: i18n.translate({ id: 'system', sourceName: 'Settings' }),
                                            function: () => setCurrentTab(SettingsTabName.system),
                                            active: currentTab === SettingsTabName.system,
                                        },
                                    ]}
                                />
                            ) : (
                                <Select
                                    value={currentTab}
                                    onChange={(tab) => {
                                        setCurrentTab(tab as SettingsTabName);
                                    }}
                                >
                                    <option value={SettingsTabName.general}>
                                        {i18n.translate({ id: 'general', sourceName: 'Settings' })}
                                    </option>
                                    <option value={SettingsTabName.dataprotection}>
                                        {i18n.translate({ id: 'dataProtection', sourceName: 'Settings' })}
                                    </option>
                                    {userSettings.isAvency && (
                                        <option value={SettingsTabName.instanceSettings}>
                                            {i18n.translate({ id: 'instance', sourceName: 'Settings' })}
                                        </option>
                                    )}
                                    <option value={SettingsTabName.themeSettings}>
                                        {i18n.translate({ id: 'themeSettings', sourceName: 'Settings' })}
                                    </option>
                                    <option value={SettingsTabName.advancedSettings}>
                                        {i18n.translate({ id: 'advancedSettings', sourceName: 'Settings' })}
                                    </option>
                                    {userSettings.expertViewEnabled && (
                                        <option value={SettingsTabName.expertSettings}>
                                            {i18n.translate({ id: 'expertSettings', sourceName: 'Settings' })}
                                        </option>
                                    )}
                                    <option value={SettingsTabName.system}>
                                        {i18n.translate({ id: 'system', sourceName: 'Settings' })}
                                    </option>
                                </Select>
                            )}
                        </div>
                        <div className="box">
                            {currentTab === 'general' && (
                                <GeneralSettings
                                    SettingsActions={SettingsActions}
                                    i18n={i18n}
                                    models={models}
                                    embeddingModels={embeddingModels}
                                    voiceModels={voiceModels}
                                    windowWidth={windowWidth}
                                    getBreakpoint={getBreakpoint}
                                    mdParser={mdParser}
                                    Currentsettings={Currentsettings}
                                />
                            )}

                            {currentTab === 'dataprotection' && (
                                <DataProtection
                                    SettingsActions={SettingsActions}
                                    i18n={i18n}
                                    Currentsettings={Currentsettings}
                                />
                            )}

                            {currentTab === 'instanceSettings' && userSettings.isAvency && (
                                <InstanceSettings
                                    SettingsActions={SettingsActions}
                                    i18n={i18n}
                                    Currentsettings={Currentsettings}
                                />
                            )}

                            {currentTab === 'advancedSettings' && (
                                <AdvancedSettings
                                    SettingsActions={SettingsActions}
                                    i18n={i18n}
                                    Currentsettings={Currentsettings}
                                />
                            )}

                            {currentTab === 'themeSettings' && (
                                <ThemeSettings
                                    SettingsActions={SettingsActions}
                                    i18n={i18n}
                                    windowWidth={windowWidth}
                                    getBreakpoint={getBreakpoint}
                                    Currentsettings={Currentsettings}
                                />
                            )}

                            {currentTab === 'system' && <System />}

                            {currentTab === 'expertSettings' && (
                                <ExpertSettings
                                    SettingsActions={SettingsActions}
                                    i18n={i18n}
                                    Currentsettings={Currentsettings}
                                />
                            )}
                        </div>
                    </>
                )}
            </AdminContainer>
        </div>
    );
}

export default Settings;
